import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { PaymentConcludedConsultantService } from 'src/environments/CheckoutConsultantAPP/pages/ConcludedPayment';
import CheckoutConsultantServices from 'src/environments/CheckoutConsultantAPP/pages/CheckoutConsultantService';
import { PaymentConcludedConsultantPlan } from 'src/environments/CheckoutConsultantAPP/pages/ConcludedPaymentPlan';
import CheckoutConsultantPlan from 'src/environments/CheckoutConsultantAPP/pages/CheckoutConsultantPlan';
import CheckoutSuitcaseMontage from 'src/environments/Checkout/pages/CheckoutSuitcaseMontage';
import OutfitsMontageService from 'src/environments/Checkout/pages/CheckoutOutfitsMontage';
import { PaymentConcluded } from 'src/environments/Checkout/pages/PaymentConcluded';
import SubscriptionCheckout from 'src/environments/Checkout/pages/CheckoutPlans';
import CheckoutProducts from 'src/environments/Checkout/pages/CheckoutProducts';
import ApproveInvite from 'src/environments/Auth/pages/ApproveInvite';
import ResetPass from 'src/environments/Auth/pages/ResetPassword';
import PathNotFound from 'src/environments/PathNotFound';
import Teste from 'src/environments/Teste';
import RedirectToStore from 'src/environments/Redirect';
import PitStopPromo from 'src/environments/PitStopPromo';
import YoutubePromo from 'src/environments/YoutubePromo';
import Promo from 'src/environments/Promo';

export default function AppRoutes(): JSX.Element {
  return (
    <Routes>
      {/* Recuperação de senha */}
      <Route path="/redefinicao-de-senha/:token" element={<ResetPass />} />

      {/* Checkout APP do cliente */}
      <Route
        path="/checkout-assinatura/:token/:platform/:planId"
        element={<SubscriptionCheckout />}
      />
      <Route
        path="/checkout-montagem-de-looks/:token/:platform/:serviceName/:couponCode"
        element={<OutfitsMontageService />}
      />
      <Route
        path="/checkout-montagem-de-looks/:token/:platform/:serviceName"
        element={<OutfitsMontageService />}
      />
      <Route
        path="/checkout-produto/:token/:platform/:productName"
        element={<CheckoutProducts />}
      />
      <Route path="/pagamento-concluido/:platform/:typeOrder" element={<PaymentConcluded />} />

      {/* Checkout APP da consultora */}
      <Route path="/checkout-servicos-consultora/:token" element={<CheckoutConsultantServices />} />
      <Route
        path="/pagamento-concluido/servico-consultora/:token"
        element={<PaymentConcludedConsultantService />}
      />
      <Route
        path="/checkout-assinatura-consultora/:token/:platform/:planId"
        element={<CheckoutConsultantPlan />}
      />
      <Route
        path="/pagamento-concluido-plano-consultora/:platform"
        element={<PaymentConcludedConsultantPlan />}
      />

      <Route path="/aprovar-convite/:token" element={<ApproveInvite />} />

      {/* Rota não encontrada */}
      <Route path="*" element={<PathNotFound />} />

      <Route path="/teste" element={<Teste />} />
      <Route path="/redirect-to-store" element={<RedirectToStore />} />
      <Route
        path="/checkout-mala-de-viagem/:token/:platform/:serviceName"
        element={<CheckoutSuitcaseMontage />}
      />
      <Route path="/pit-stop-resolva-promo" element={<PitStopPromo />} />
      <Route path="/youtube-resolva-promo" element={<YoutubePromo />} />
      <Route path="/resolva-promo/:type" element={<Promo />} />
    </Routes>
  );
}
